import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

const PermissionCheck = () => {
  const navigate = useNavigate();

  useEffect(() => {
    if (localStorage.getItem("no_permission") === "true") {
      navigate("/no-permission");
    }
  }, []);

  return null;
};

export default PermissionCheck;
